import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";

// Layout
import { Layout } from "./components/layout/Layout";
import { ScrollToTop } from "./components/ScrollToTop";

// Pages
import { HomePage } from "./pages/HomePage";
import { AboutPage } from "./pages/AboutPage";
import { CoachingPage } from "./pages/CoachingPage";
import { TarotPage } from "./pages/TarotPage";
import { CollectivePage } from "./pages/CollectivePage";
import { CollectiveDetailPage } from "./pages/CollectiveDetailPage";
import { CollectiveMarch2026Page } from "./pages/CollectiveMarch2026Page";
import { CollectiveApril2026Page } from "./pages/CollectiveApril2026Page";
import { CollectiveMay2026Page } from "./pages/CollectiveMay2026Page";
import { CollectiveJune2026Page } from "./pages/CollectiveJune2026Page";
import { ToolkitPage } from "./pages/ToolkitPage";
import { ContactPage } from "./pages/ContactPage";
import { ThankYouPage } from "./pages/ThankYouPage";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/coaching" element={<CoachingPage />} />
            <Route path="/tarot" element={<TarotPage />} />
            <Route path="/collective" element={<CollectivePage />} />
            <Route path="/collective/march-2026" element={<CollectiveMarch2026Page />} />
            <Route path="/collective/april-2026" element={<CollectiveApril2026Page />} />
            <Route path="/collective/may-2026" element={<CollectiveMay2026Page />} />
            <Route path="/collective/june-2026" element={<CollectiveJune2026Page />} />
            <Route path="/collective/:slug" element={<CollectiveDetailPage />} />
            <Route path="/toolkit" element={<ToolkitPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/thank-you" element={<ThankYouPage />} />
          </Routes>
        </Layout>
        <Toaster 
          position="bottom-right"
          toastOptions={{
            style: {
              background: '#1C1C1C',
              border: '1px solid rgba(45, 31, 61, 0.3)',
              color: '#F5F0E8',
            },
          }}
        />
      </BrowserRouter>
    </div>
    </HelmetProvider>
  );
}

export default App;
